// Optional view modules (political extras, sites, overlays) plug in here without editing the core.
//
//   mount() ── core ready ──▶ install(core) ──▶ warm(x, y, z) during warmUp ──▶ frames
//   setSnapshot / setLens / setMode ──▶ each module's hook, in registry order
//
// Each module owns one folder and its install.ts; add a module by importing it below.

import type { LensResult, WorldSnapshot } from '../world/api.ts';
import type { ViewMode } from './api.ts';
import type { ViewCore } from './index.ts';
import { political } from './political/install.ts';
import { sites } from './sites/install.ts';
import { overlays } from './overlays/install.ts';

export interface ViewModule {
  name: string;
  install(core: ViewCore): void | Promise<void>;
  /** Show one of everything near (x, y, z) so its pipelines compile behind the loading card. */
  warm?(x: number, y: number, z: number): void;
  setSnapshot?(snapshot: WorldSnapshot): void;
  setLens?(lens: LensResult | null): void;
  setMode?(mode: ViewMode): void;
  /** Markers drawn this frame without a source id (truth rule 1); summed into the harness gate. */
  unsourced?(): number;
  dispose?(): void;
}

export const MODULES: readonly ViewModule[] = [political, sites, overlays];
